import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/system';
import { CenterCircularProgress } from '@europrocurement/flexy-components';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { parcoursFormalitePathResolver } from '../parcoursFormalitePathResolver';
import { useParcoursFormalite, useParcoursFormalitreHeader } from '../provider';
import CurrentFormalityAndClient from '../components/currentFormalityAndClient';

const StepNextForm: React.FunctionComponent = function () {
    const navigate = useNavigate();

    const { indexPresta: strIndexPresta, page: strpage } = useParams();

    if (strIndexPresta === undefined || strpage === undefined) {
        throw new Error('missing page');
    }

    const page = Number(strpage === undefined ? 0 : strpage);
    const indexPresta = Number(strIndexPresta === undefined ? 0 : strIndexPresta);

    const { fetchForm, refreshDossier, getCurrentDossier, setLoading } = useParcoursFormalite();

    const { setIsParcoursPath } = useParcoursFormalitreHeader();

    const { setProfileHeaderVisible } = useFullLayout();
    React.useEffect(() => {
        setProfileHeaderVisible(false);
        setIsParcoursPath(true);
        return () => {
            setIsParcoursPath(false);
            setProfileHeaderVisible(true);
        };
    }, [setIsParcoursPath, setProfileHeaderVisible]);

    React.useEffect(() => {
        setLoading(false);
    }, [setLoading]);

    React.useEffect(() => {
        const hook = async () => {
            setLoading(true);
            const doss = getCurrentDossier();
            if (doss && doss.id) {
                await refreshDossier(doss.id);
            }
            await fetchForm();
            navigate(parcoursFormalitePathResolver('stepForm', indexPresta, page));
        };
        hook();
    }, [fetchForm, getCurrentDossier, indexPresta, navigate, page, refreshDossier, setLoading]);

    return (
        <Box>
            <CurrentFormalityAndClient />
            <CenterCircularProgress sx={{ height: '500px' }} />
        </Box>
    );
};

export default StepNextForm;
